<template>
  <triviaSessionLiveComponent />
</template>

<script>
import triviaSessionLiveComponent from "@/views/trivia/pages/trivia_session/components/trivia_session_live_component.vue"
export default {
  name: "triviaSessionLivePage",
  components: {
    triviaSessionLiveComponent
  },
}
</script>
